module.exports = __webpack_public_path__ + "static/media/ic-recommendation-mobile-dei.a671e213.png";